import AuthLayout from "./AuthLayout";
import LoginForm from "./LoginForm";

const Login = () => {
  return (
    <AuthLayout headerText="Log in to Choir Script ">
      <LoginForm />
    </AuthLayout>
  );
};

export default Login;
